import React from "react";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { connect } from "react-redux";
import Icon from "./Icons";

const showPreview = (pageUrl) => {
  window.open(pageUrl, "_blank");
};

let UndoRedo = ({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  undoCount,
  redoCount,
  url,
}) => (
  <div className="undo-redo">
    <button onClick={onUndo} disabled={!canUndo}>
      <Icon icon="undo" />
      {undoCount > 0 && <span>{undoCount}</span>}
    </button>
    <button onClick={onRedo} disabled={!canRedo}>
      <Icon icon="redo" />
      {redoCount > 0 && <span>{redoCount}</span>}
    </button>
    {url && (
      <button
        onClick={() => {
          showPreview(url);
        }}
      >
        <Icon icon="eye" />
      </button>
    )}
  </div>
);

/* ... */

const mapStateToProps = (state) => {
  return {
    canUndo: state.undo.past.length > 0,
    undoCount: state.undo.past.length,
    canRedo: state.undo.future.length > 0,
    redoCount: state.undo.future.length,
    url: state.rootReducer.previewUrl || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUndo: (e) => {
      e.stopPropagation();
      dispatch({ type: "HISTORYING", bool: true });
      dispatch(UndoActionCreators.undo());
    },
    onRedo: (e) => {
      e.stopPropagation();
      dispatch({ type: "HISTORYING", bool: true });
      dispatch(UndoActionCreators.redo());
    },
  };
};

UndoRedo = connect(mapStateToProps, mapDispatchToProps)(UndoRedo);

export default UndoRedo;
